import axios from "axios";
import { API } from "../../const";
// import { normParam } from "@/tools";

const M_API = API + "/api";
const store = {
  namespaced: true,
  actions: {
    // eslint-disable-next-line
    getPeran({ state, commit }, { instansi_id, params }) {
      // return axios
      //   .get(`${M_API}/instansi/${instansi_id}/diklat${normParam(params)}`)
      //   .then(res => {
      //     return res.data;
      //   })
      //   .catch(err => Promise.reject(err));
      return {
        data: [
          {
            jenis_diklat: {
              id: 1,
              keterangan: "Pelatih Ahli"
            },
            role_moodle: {
              id: 1,
              keterangan: "Admin LMS"
            },
            group: {
              id: 1,
              keterangan: "Kordinator"
            }
          }
        ]
      };
    },
    getJenisDiklat() {
      return axios
        .get(`${M_API}/jenis_diklat`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    getPeranSIM() {
      return axios
        .get(`${M_API}/m_group`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    getPeranLMS() {
      return axios
        .get(`${M_API}/m_role_moodle`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    formKelolaPeran(_, obj) {
      return axios
        .post(`${M_API}/jenis_diklat`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    }
  }
};

export default store;
